module.exports = __webpack_public_path__ + "img/google.56e54bf0.svg";